import { MonthlyStatsFieldsFragment } from '@app/generated/graphql';
import { MonthlyStatsView } from './my-monthly-stats.model';

export function toMonthlyStatsView(stats: MonthlyStatsFieldsFragment): MonthlyStatsView {
  const newLeadConversionRate = stats.leads.newLeadConversionRate ?? null;
  const baselineNlcr = stats.leads.baselineNlcr ?? null;
  const ancillaryAttachRate = stats.deals.ancillaryAttachRate;
  const baselineAncillaryAttachRate = stats.deals.baselineAncillaryAttachRate ?? null;

  return {
    lastSyncedAt: stats.lastSyncedAt ?? undefined,
    gp: {
      target: stats.gp.target ?? null,
      monthToDate: stats.gp.monthToDate,
      corrections: stats.gp.corrections,
      completed: stats.gp.completed ?? null,
      projection: stats.gp.projection ?? null,
      projectedCompletion: stats.gp.projectedCompletion ?? null,
    },
    workingDays: stats.workingDays
      ? {
          total: stats.workingDays.total,
          remaining: stats.workingDays.remaining,
        }
      : null,
    leads: {
      assigned: stats.leads.assigned,
      converted: stats.leads.converted,
      baselineNlcr,
      newLeadConversionRate,
    },
    deals: {
      closed: stats.deals.closed,
      blendedGpPerDeal: stats.deals.blendedGpPerDeal,
      withAncillaries: stats.deals.withAncillaries,
      withoutAncillaries: stats.deals.withoutAncillaries,
      ancillaryAttachRate,
      baselineAncillaryAttachRate,
    },
    nlcrMeetsBaseline: meetsBaseline(newLeadConversionRate, baselineNlcr),
    ancillaryMeetsBaseline: meetsBaseline(ancillaryAttachRate, baselineAncillaryAttachRate),
  };
}

function meetsBaseline(value: number | null, baseline: number | null) {
  if (value == null || baseline == null) {
    return null;
  }

  return value >= baseline;
}
